import React from "react";
import { Typography } from "../../../../components/__common/Typography/Typography";
import { useTranslation } from "react-i18next";
import { SVG_ICONS, Svg } from "../../../../components/__common/Svg/Svg";

enum types {
  ACCESS,
  APPEAL,
  CORRECT,
  DELETE,
  DONOTSELL,
  OPTOUT,
  RESTRICT,
  PORTABILITY,
  OBJECT,
}

enum regions {
  USA,
  LATAM,
  ASIA,
  EUROPE,
  TURKIYE,
  CHINA,
  OTHERS,
}

interface Props {
  type: keyof typeof types;
  region: keyof typeof regions | string;
}

const Rights: React.FC<Props> = ({ type, region }) => {
  const { t } = useTranslation();

  return (
    <div className="privacy-rights-modal__section">
      <Typography
        variant="title3"
        className="privacy-rights-modal__section__heading"
      >
        {t(`PRIVCY_HUB_MODAL_PRIVACY_RIGHTS_${region}`)}
      </Typography>
      <Svg
        icon={SVG_ICONS[`HUB_RIGHTS_MAP_${region}`]}
        width={300}
        height={200}
      />
      <Typography
        variant="title2"
        className="privacy-rights-modal__section__title"
      >
        {t(`PRIVCY_HUB_MODAL_PRIVACY_RIGHTS_${type}_TITLE`)}
      </Typography>
      {type === "DONOTSELL" && (
        <Typography
          variant="title2"
          className="privacy-rights-modal__section__subtitle"
        >
          {t("PRIVCY_HUB_MODAL_PRIVACY_RIGHTS_DONOTSELL_TITLE2")}
        </Typography>
      )}
      <Typography variant="body1" weight="wMedium">
        {t(`PRIVCY_HUB_MODAL_PRIVACY_RIGHTS_${type}_DETAIL`)}
      </Typography>
    </div>
  );
};

export default Rights;
